import {
  useAccountDrawerStore,
  useAccountTransactionDrawerStore,
  useClientDrawerStore,
  useContactDrawerStore,
  useDriverDrawerStore,
  useInvoiceDrawerStore,
  useOrderDrawerStore,
  useSavedLocationDrawerStore,
  useVehicleDrawerStore,
} from '@hero/hooks-shared';
import { normalizeEntityId } from './normalizeEntityId';

/** Entity kinds the chat can deep-link into existing CRM drawers. */
export type HeroEntityKind =
  | 'client'
  | 'contact'
  | 'order'
  | 'driver'
  | 'vehicle'
  | 'saved_location'
  | 'invoice'
  | 'account'
  | 'transaction';

/**
 * Open the host app's stacked drawer for a known entity type.
 * Chat never duplicates drawer logic — it delegates to the same
 * Zustand stores the rest of the dashboard uses.
 */
export const openEntityDrawer = (kind: HeroEntityKind, id: string): void => {
  const entityId = normalizeEntityId(id);
  if (!entityId) return;
  switch (kind) {
    case 'client':
      useClientDrawerStore.getState().open(entityId);
      break;
    case 'contact':
      useContactDrawerStore.getState().open(entityId);
      break;
    case 'order':
      useOrderDrawerStore.getState().open(entityId);
      break;
    case 'driver':
      useDriverDrawerStore.getState().open(entityId);
      break;
    case 'vehicle':
      useVehicleDrawerStore.getState().open(entityId);
      break;
    case 'saved_location':
      useSavedLocationDrawerStore.getState().open(entityId);
      break;
    case 'invoice':
      useInvoiceDrawerStore.getState().open(entityId);
      break;
    case 'account':
      useAccountDrawerStore.getState().open(entityId);
      break;
    case 'transaction':
      useAccountTransactionDrawerStore.getState().open(entityId);
      break;
  }
};
